import {
  Group,
  Box,
  Divider,
  HoverCard,
  Center,
  useMantineTheme,
  Text,
  UnstyledButton,
  ThemeIcon,
  SimpleGrid,
} from "@mantine/core";

import { IconChevronDown } from "@tabler/icons";


export const HeaderMegaMenu = (props) => {
  const theme = useMantineTheme();

  const subLinks = props?.mockdata.map((item) => (
    <UnstyledButton
      component="a"
      href={item.link}
      className={props?.classes.subLink}
      key={item.title}
      style={{
        transition: "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
      }}
    >
      <Group wrap="nowrap" align="flex-start" gap="md">
        <ThemeIcon
          size={40}
          variant="light"
          radius="md"
          style={{
            background: "linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%)",
            border: "1px solid rgba(102, 126, 234, 0.2)",
            transition: "all 0.3s ease",
          }}
        >
          <item.icon size={22} color="#667eea" />
        </ThemeIcon>
        <div style={{ flex: 1 }}>
          <Text size="sm" fw={600} c="dark.7" mb={4}>
            {item.title}
          </Text>
          <Text size="xs" c="dimmed" lineClamp={2}>
            {item.description}
          </Text>
        </div>
      </Group>
    </UnstyledButton>
  ));
  return (
    <HoverCard
      width={650}
      position="bottom"
      radius="lg"
      shadow="xl"
      withinPortal
      openDelay={100}
      closeDelay={200}
      styles={{
        dropdown: {
          background: "rgba(255, 255, 255, 0.98)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(102, 126, 234, 0.1)",
          padding: 0,
        },
      }}
    >
      <HoverCard.Target>
        <a href="#" className={props?.classes.link} style={{ textDecoration: "none" }}>
          <Center inline>
            <Box component="span" mr={5} fw={600}>
              פתרונות לפי תחום
            </Box>
            <IconChevronDown
              size={16}
              style={{
                color: "#667eea",
                transition: "transform 0.3s ease",
              }}
            />
          </Center>
        </a>
      </HoverCard.Target>

      <HoverCard.Dropdown style={{ overflow: "hidden", padding: "var(--mantine-spacing-lg)" }}>
        <Group justify="space-between" mb="md">
          <Text fw={700} size="lg" c="dark.8">
            פתרונות לפי תחום
          </Text>
        </Group>

        <Divider
          my="md"
          style={{
            borderColor: "rgba(102, 126, 234, 0.1)",
          }}
        />

        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
          {subLinks}
        </SimpleGrid>

        {/* <div className={props?.classes.dropdownFooter}>
    <Group justify="flex-end">
      <div>
        <Image
          src="/whatsapp-reminder2.webp"
          alt="ניהול תורים לקוסמטיקאיות"
   width={400}
   height={300}
          radius="md"
        />

      </div>
      {/* <Button variant="default">Get started</Button> */}
        {/* </Group>
  </div>  */}
      </HoverCard.Dropdown>
    </HoverCard>
  );
};
